module.exports = __webpack_public_path__ + "img/bottomimg.4778a62.png";